import { FormControl, InputLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import styles from "../Cadastro.module.css";
import InputMask from "react-input-mask";
import { HelperText } from "../../../../components/Errors/HelperText";
import { TipoGeracaoSearchField } from "../../../../components/Searchfields/TipoGeracao";
import { TipoInscricao } from "../../../../components/Combobox/TipoInscricao";
import { useEffect, useState } from "react";
import { formatarTelefone } from "../../../../infra/utils/FormataValores";
import { maskUC } from "../../../../infra/utils/maskUC";

const Geral = ({
    setIsLoading,
    setOpenError,
    setErrorMessage,
    recuperarDadosConsumidor,
    camposDesabilitados,
    camposDesabilitadosSeHouverProtocolo,
    camposDesabilitadosUc,
    erroAoRecuperarConsumidor,
    onKeyDown,
    desabilitarUcInscricao,
    uc }) => {
    const { control, getValues, formState: { errors } } = useFormContext();
    const [mascaraTelefone1, setMascaraTelefone1] = useState("(99) 99999-9999");
    const [mascaraTelefone2, setMascaraTelefone2] = useState("(99) 99999-9999");

    useEffect(() => {

        maskBuilderTelefone1(getValues("Celular1"));
        maskBuilderTelefone2(getValues("Celular2"));

    }, [getValues("Celular1"), getValues("Celular2")]);

    const maskBuilder = (telefone) => {
        if (!telefone || telefone.trim().length === 0 || telefone.trim().length < 8) return "(99) 99999-9999";

        let mascara = '';

        switch (telefone.trim().length) {
            case 8:
                mascara = "9999-9999";
                break;
            case 9:
                mascara = "99999-9999";
                break;
            case 10:
                mascara = "(99) 9999-9999";
                break
            case 11:
                mascara = "(99) 99999-9999";
                break;
            default:
                break;
        }

        return mascara;
    }

    const maskBuilderTelefone1 = (telefone) => {
        let mascara = maskBuilder(telefone);

        setMascaraTelefone1(mascara);
    }

    const maskBuilderTelefone2 = (telefone) => {
        let mascara = maskBuilder(telefone);

        setMascaraTelefone2(mascara);
    }

    return (
        <div style={{ width: "100%" }}>
            <div className={styles['input-container']}>
                <Controller
                    name="CodigoTipoGeracao"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 3 }}>
                            <InputLabel htmlFor="consulta-CodigoTipoGeracao" shrink sx={{ color: "#b8b8b8" }}>Tipo fonte primária</InputLabel>
                            <TipoGeracaoSearchField field={field} setErrorMessage={setErrorMessage} setOpenError={setOpenError} id="consulta-CodigoTipoGeracao" readOnly={camposDesabilitados} disabled={camposDesabilitados} onKeyDown={onKeyDown} className={`${errors?.CodigoTipoGeracao ? styles.campoComValorErrado : ""}`} />
                            {errors?.CodigoTipoGeracao ? (
                                <HelperText text="Esse campo é obrigatório!" />
                            ) : ''}

                        </FormControl>
                    )}
                />

                <Controller
                    name="CodigoUC"
                    control={control}
                    render={({ field }) => {
                        const isNovaUC = uc.rn1095;

                        return (
                            <FormControl
                                variant="outlined"
                                className={styles['campos-m']}
                                style={{ zIndex: 2 }}
                                onBlur={() => recuperarDadosConsumidor()}
                            >
                                <InputLabel shrink sx={{ color: "#b8b8b8" }}>
                                    {isNovaUC
                                        ? "Unidade Consumidora"
                                        : "Unidade consumidora* (sem dígito)"}
                                </InputLabel>

                                <WhiteInput
                                    fullWidth
                                    placeholder={isNovaUC ? "Unidade Consumidora" : "Unidade consumidora"}
                                    type={isNovaUC ? "text" : "number"}
                                    name="CodigoUC"
                                    id="consulta-uc"
                                    readOnly={desabilitarUcInscricao}
                                    disabled={desabilitarUcInscricao}
                                    value={isNovaUC ? maskUC(field.value || "") : field.value || ""}
                                    onChange={(e) => {
                                        if (isNovaUC) {
                                            const raw = e.target.value.replace(/\D/g, "");
                                            field.onChange(raw);
                                        } else {
                                            field.onChange(e.target.value);
                                        }
                                    }}
                                    onKeyDown={onKeyDown}
                                    className={errors?.CodigoUC ? styles.campoComValorErrado : ""}
                                />

                                {errors?.CodigoUC && (
                                    <HelperText text={errors?.CodigoUC?.message} />
                                )}
                            </FormControl>
                        );
                    }}
                />
            </div>

            {erroAoRecuperarConsumidor && <p className={styles.erroAoRecuperarConsumidor}>Não foi encontrado um consumidor com a combinação de Inscrição e UC utilizadas</p>}

            <div className={`${styles['input-container']} ${erroAoRecuperarConsumidor && styles['input-container-error']}`}>
                <Controller
                    name="TipoInscricao"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }}>
                            <InputLabel htmlFor="consulta-tipoInscricao" shrink sx={{ color: "#b8b8b8" }}>Tipo de inscrição</InputLabel>
                            <TipoInscricao
                                field={field}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                id="consulta-tipoInscricao"
                                name="consulta-tipoInscricao"
                                placeholder="Selecione o tipo"
                                readOnly={camposDesabilitados || camposDesabilitadosUc || desabilitarUcInscricao}
                                disabled={camposDesabilitados || camposDesabilitadosUc || desabilitarUcInscricao}
                                onKeyDown={onKeyDown}
                                className={`${errors?.TipoInscricao ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.TipoInscricao ? (
                                <HelperText text={"Campo obrigatório"} />
                            ) : ''}
                        </FormControl>
                    )}
                />

                <Controller
                    name="Inscricao"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} onBlur={() => recuperarDadosConsumidor()}>
                            <InputLabel htmlFor="consulta-inscricao" shrink sx={{ color: "#b8b8b8" }} >Inscrição</InputLabel>
                            <InputMask
                                mask={getValues('TipoInscricao').value == 1 ? "999.999.999-99" : "**.***.***/****-99"}
                                onChange={onChange}
                                value={value}
                                id="consulta-inscricao"
                                readOnly={desabilitarUcInscricao}
                            >
                                {inputProps => (
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Inscrição"
                                        name="Inscricao"
                                        {...inputProps}
                                        readOnly={desabilitarUcInscricao}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Inscricao ? styles.campoComValorErrado : ""}`}
                                    />
                                )}
                            </InputMask>
                            {errors?.Inscricao ? (
                                <HelperText text={errors?.Inscricao?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles['input-container']}>
                <Controller
                    name="Nome"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-nome" shrink sx={{ color: "#b8b8b8" }}>Nome</InputLabel>
                            <WhiteInput
                                fullWidth
                                placeholder="Nome"
                                type="text"
                                id="consulta-nome"
                                name="Nome"
                                {...field}
                                readOnly={camposDesabilitados || camposDesabilitadosUc}
                                onKeyDown={onKeyDown}
                                className={`${errors?.Nome ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.Nome ? (
                                <HelperText text={errors?.Nome?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />

                <Controller
                    name="Email"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-email" shrink sx={{ color: "#b8b8b8" }}>E-mail</InputLabel>
                            <WhiteInput
                                fullWidth
                                placeholder="E-mail"
                                type="email"
                                id="consulta-email"
                                name="Email"
                                {...field}
                                readOnly={camposDesabilitados}
                                onKeyDown={onKeyDown}
                                className={`${errors?.Email ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.Email ? (
                                <HelperText text={errors?.Email?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles['input-container']}>
                <Controller
                    name="Celular1"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-celular1" shrink sx={{ color: "#b8b8b8" }}>Telefone Cel.</InputLabel>
                            <InputMask
                                mask={mascaraTelefone1}
                                onChange={onChange}
                                value={value}
                                id="consulta-celular1"
                                readOnly={camposDesabilitados || camposDesabilitadosUc}
                                onBlur={
                                    (event) => {
                                        let foneFormatado = formatarTelefone(event.target.value);

                                        maskBuilderTelefone1(foneFormatado);
                                    }
                                }
                                onFocus={
                                    (event) => {
                                        setMascaraTelefone1("(99) 99999-9999");
                                    }
                                }
                            >
                                {inputProps => (
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Telefone"
                                        name="FoneCelular1"
                                        {...inputProps}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Celular1 ? styles.campoComValorErrado : ""}`}
                                        readOnly={camposDesabilitados || camposDesabilitadosUc}
                                    />
                                )}
                            </InputMask>
                            {errors?.Celular1 ? (
                                <HelperText text={errors?.Celular1?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />

                <Controller
                    name="Celular2"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="consulta-celular2" shrink sx={{ color: "#b8b8b8" }}>Telefone alt.</InputLabel>
                            <InputMask
                                mask={mascaraTelefone2}
                                onChange={onChange}
                                value={value}
                                id="consulta-celular2"
                                readOnly={camposDesabilitados || camposDesabilitadosUc}
                                onBlur={
                                    (event) => {
                                        let foneFormatado = formatarTelefone(event.target.value);

                                        maskBuilderTelefone2(foneFormatado);
                                    }
                                }
                                onFocus={
                                    (event) => {
                                        setMascaraTelefone2("(99) 99999-9999");
                                    }
                                }
                            >
                                {inputProps => (
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Telefone"
                                        name="Celular2"
                                        {...inputProps}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Celular2 ? styles.campoComValorErrado : ""}`}
                                        readOnly={camposDesabilitados || camposDesabilitadosUc}
                                    />
                                )}
                            </InputMask>
                            {errors?.Celular2 ? (
                                <HelperText text={errors?.Celular2?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />
            </div>
        </div>
    )
};


export { Geral };